<script>
import SpellCheckedText from "@/components/SpellCheckedText.vue";
import PhotoBox from "../../PhotoBox.vue";

export default {
    name: "LPTemp4",
    components: {
        SpellCheckedText,
        PhotoBox
    },
    props: ["proposal"],
    data() {
        return {
            bannerImage: "",
            footerImage: ""
        };
    },
    computed: {
        project() {
            return this.proposal.projects && this.proposal.projects.length > 0
                ? this.proposal.projects[0]
                : null;
        },
        headerColor() {
            return (this.proposal && this.proposal.style && this.proposal.style.colorScheme && this.proposal.style.colorScheme.header) || '#e66e2d';
        },
        bodyColor() {
            return (this.proposal && this.proposal.style && this.proposal.style.colorScheme && this.proposal.style.colorScheme.body) || '#e66e2d';
        },
        footerColor() {
            return (this.proposal && this.proposal.style && this.proposal.style.colorScheme && this.proposal.style.colorScheme.footer) || '#e66e2d';
        }
    },
    watch: {
        headerColor() { this.generateGradients(); },
        bodyColor() { this.generateGradients(); },
        footerColor() { this.generateGradients(); }
    },
    mounted() {
        this.generateGradients();
    },
    methods: {
        hexToRGBA(hex, opacity) {
            if (!hex || !hex.startsWith('#')) return hex;
            let r = 0, g = 0, b = 0;
            if (hex.length === 4) {
                r = parseInt(hex[1] + hex[1], 16);
                g = parseInt(hex[2] + hex[2], 16);
                b = parseInt(hex[3] + hex[3], 16);
            } else if (hex.length === 7) {
                r = parseInt(hex.substring(1, 3), 16);
                g = parseInt(hex.substring(3, 5), 16);
                b = parseInt(hex.substring(5, 7), 16);
            }
            return `rgba(${r},${g},${b},${opacity})`;
        },
        generateGradients() {
            // Banner Gradient (Down)
            const bCanvas = document.createElement('canvas');
            bCanvas.width = 800;
            bCanvas.height = 80;
            const bCtx = bCanvas.getContext('2d');
            const bGrad = bCtx.createLinearGradient(0, 0, 0, 80);
            bGrad.addColorStop(0, this.hexToRGBA(this.headerColor, 0.8));
            bGrad.addColorStop(1, this.hexToRGBA(this.headerColor, 0));
            bCtx.fillStyle = bGrad;
            bCtx.fillRect(0, 0, 800, 80);
            this.bannerImage = bCanvas.toDataURL();

            // Footer Gradient (Up)
            const fCanvas = document.createElement('canvas');
            fCanvas.width = 800;
            fCanvas.height = 300;
            const fCtx = fCanvas.getContext('2d');
            const fGrad = fCtx.createLinearGradient(0, 300, 0, 0);
            fGrad.addColorStop(0, this.hexToRGBA(this.footerColor, 0.8));
            fGrad.addColorStop(1, 'rgba(255, 255, 255, 0.5)');
            fCtx.fillStyle = fGrad;
            fCtx.fillRect(0, 0, 800, 300);
            this.footerImage = fCanvas.toDataURL();
        }
    }
};
</script>

<template>
    <div class="main-container" :style="{
        '--header-color': headerColor,
        '--body-color': bodyColor,
        '--footer-color': footerColor,
        '--heading-color': proposal.style.heading.color,
        '--heading-size': proposal.style.heading.size + 'px',
        '--heading-font': proposal.style.heading.font,
        '--heading-bold': proposal.style.heading.bold ? 700 : 400,
        '--heading-italic': proposal.style.heading.italic ? 'italic' : 'normal',
        '--heading-underline': proposal.style.heading.underline ? 'underline' : 'none',
        '--label-color': proposal.style.label.color,
        '--label-size': proposal.style.label.size + 'px',
        '--label-font': proposal.style.label.font,
        '--label-bold': proposal.style.label.bold ? 700 : 400,
        '--label-italic': proposal.style.label.italic ? 'italic' : 'normal',
        '--label-underline': proposal.style.label.underline ? 'underline' : 'none',
        '--text-color': proposal.style.text.color,
        '--text-size': proposal.style.text.size + 'px',
        '--text-font': proposal.style.text.font,
        '--text-bold': proposal.style.text.bold ? 700 : 400,
        '--text-italic': proposal.style.text.italic ? 'italic' : 'normal',
        '--text-underline': proposal.style.text.underline ? 'underline' : 'none',
    }">
        <div class="lastPage">
            <!-- Header Section -->
            <div class="header-sec">
                <div class="banner-gradient">
                    <img v-if="bannerImage" :src="bannerImage" class="w-full h-full" />
                </div>
                <div class="logo-box photobox">
                    <PhotoBox :project="proposal" type="logo" bgColor="transparent" objectFit="contain" />
                </div>
            </div>

            <!-- Main Photo Section -->
            <div class="photo-sec">
                <PhotoBox v-if="project" class="photobox" :project="project"
                    :bgColor="proposal.style.colorScheme && proposal.style.colorScheme.body" />
                <div v-else class="imageBox" />
            </div>

            <!-- Footer Section (Overlapping) -->
            <div class="footer-sec">
                <div class="footer-gradient">
                    <img v-if="footerImage" :src="footerImage" class="w-full h-full" />
                </div>
                <div class="footer-content">
                    <div class="detail-sec">
                        <p class="name">
                            <SpellCheckedText :value="proposal.name || ''" @input="proposal.name = $event" />
                        </p>
                        <p>
                            <SpellCheckedText :value="proposal.address || ''" @input="proposal.address = $event" />
                        </p>
                        <p>
                            <SpellCheckedText :value="proposal.city || ''" @input="proposal.city = $event" />,
                            <SpellCheckedText :value="proposal.stateProvince || ''"
                                @input="proposal.stateProvince = $event" />
                        </p>
                        <p>
                            <SpellCheckedText :value="proposal.contactNo || ''" @input="proposal.contactNo = $event" />
                        </p>
                        <p>
                            <SpellCheckedText :value="proposal.email || ''" @input="proposal.email = $event" />
                        </p>
                        <p>
                            <SpellCheckedText :value="proposal.website || ''" @input="proposal.website = $event" />
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.main-container {
    display: block;
    width: 211mm;
    height: 296.83mm;
    min-height: 296.83mm;
    position: relative;
    box-sizing: border-box;
    background: white;
    overflow: hidden;

    &:hover {
        .photobox :deep(.photo-overlay) {
            opacity: 1;
        }

        .photobox :deep(img) {
            opacity: 0.9;
        }
    }

    .lastPage {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        position: relative;

        .header-sec {
            position: relative;
            height: 80px;
            display: flex;
            justify-content: space-between;
            position: relative;
            background: white;

            .banner-gradient {
                flex: 1;
                height: 100%;
            }

            .logo-box {
                position: absolute;
                top: 0;
                right: 0;
                width: 193px;
                height: 80px;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 10px;
            }
        }

        .photo-sec {
            flex: 1;
            width: 100%;
            position: relative;
            z-index: 1;

            img {
                width: 100%;
                height: 100%;
                object-fit: fill;
            }

            .imageBox {
                width: 100%;
                height: 100%;
                background: var(--body-color);
            }
        }

        .footer-sec {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            min-height: 250px;
            height: fit-content;
            z-index: 2;
            display: flex;
            flex-direction: column;

            .footer-gradient {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                pointer-events: none;
            }

            .footer-content {
                position: relative;
                z-index: 3;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                padding: 80px 80px 40px 80px;
                color: white;

                .detail-sec {
                    text-align: center;
                    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
                    line-height: 1.2;

                    .name {
                        color: var(--label-color);
                        font-size: var(--label-size);
                        font-family: var(--label-font);
                        font-weight: var(--label-bold);
                        font-style: var(--label-italic);
                        text-decoration: var(--label-underline);
                    }

                    p {
                        margin: 0px;
                        color: var(--text-color);
                        font-size: var(--text-size);
                        font-family: var(--text-font);
                        font-weight: var(--text-bold);
                        font-style: var(--text-italic);
                        text-decoration: var(--text-underline);
                    }
                }
            }
        }
    }
}
</style>
